import React, { useState, useEffect, useRef } from "react";
import {
    MdLogout,
    MdNotificationsActive,
    MdOutlineMarkEmailRead,
    MdOutlineMarkEmailUnread,
} from "react-icons/md";
import { IoNotificationsOutline } from "react-icons/io5";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { getApiInstance } from "../../utils/api";
import Button from "../button/button";
import "./navbar.scss";
import { PiClockCounterClockwise } from "react-icons/pi";
import { formatDateComment } from "../../utils/utils";
import Logo from "../../assets/img/logo-b.png";
import { PiDownloadSimple } from "react-icons/pi";

export default function Navbar({ onLogout }) {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isNotificationMenuOpen, setIsNotificationMenuOpen] = useState(false);
    const [isHistoryMenuOpen, setIsHistoryMenuOpen] = useState(false);
    const [user, setUser] = useState(null);
    const [notificaciones, setNotificaciones] = useState([]);
    const avatarRef = useRef(null);
    const notificationRef = useRef(null);
    const historyRef = useRef(null);
    const [categoriaPlano, setCategoriaPlano] = useState("");
    const [descargandoPlano, setDescargandoPlano] = useState(false);
    const navigate = useNavigate();

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const toggleNotificationMenu = () => {
        setIsNotificationMenuOpen(!isNotificationMenuOpen);
    };

    const handleClickOutside = (event) => {
        if (
            notificationRef.current &&
            notificationRef.current.contains(event.target)
        ) {
            return;
        }

        if (avatarRef.current && !avatarRef.current.contains(event.target)) {
            setIsMenuOpen(false);
        }
        if (
            notificationRef.current &&
            !notificationRef.current.contains(event.target)
        ) {
            setIsNotificationMenuOpen(false);
        }
        if (historyRef.current && !historyRef.current.contains(event.target)) {
            setIsHistoryMenuOpen(false);
        }
    };

    const handleNotificationClick = (e, enlace) => {
        const selection = window.getSelection();
        if (selection && selection.toString().length > 0) {
            return;
        }

        navigate(enlace);
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const api = getApiInstance();
                const response = await api.get("/api/Usuario/GetCurrentUser");
                setUser(response.data);
            } catch (error) {
                console.error("Error fetching user data:", error);
            }
        };

        fetchUserData();
    }, []);

    useEffect(() => {
        const fetchNotificacionesData = async () => {
            if (user != null) {
                try {
                    const api = getApiInstance();
                    const response = await api.get(
                        `/api/Notificaciones/GetNewNotificacionesByCodUsuarioAsync?codUsuario=${user.codUsuario}`
                    );
                    setNotificaciones(response.data);
                } catch (error) {
                    console.error("Error fetching notifications data:", error);
                }
            }
        };

        fetchNotificacionesData();
    }, [user]);

    const fetchReadNotifications = async () => {
        if (notificaciones.length > 0) {
            try {
                const api = getApiInstance();

                const formData = new FormData();
                notificaciones.forEach((notificacion) => {
                    formData.append(
                        "CodsNotifications",
                        notificacion.codNotificacion
                    );
                });

                const response = await api.post(
                    "/api/Notificaciones/ReadNotifications",
                    formData
                );
                console.log(response.data);
            } catch (error) {
                console.error("Error reading notifications data:", error);
            }

            setNotificaciones([]);
        }
    };

    const handleDeleteAllNotifications = () => {
        fetchReadNotifications();
    };

    const handleDeleteNotification = async (codNotificacion) => {
        try {
            const api = getApiInstance();
            const response = await api.post(
                `/api/Notificaciones/ReadNotification?codNotificacion=${codNotificacion}`
            );
            console.log(response.data);
        } catch (error) {
            console.error("Error reading notification data:", error);
        }
    };

    const handleMarkAsRead = async (codNotificacion) => {
        setNotificaciones((prevNotificaciones) =>
            prevNotificaciones.map((notificacion) =>
                notificacion.codNotificacion === codNotificacion
                    ? { ...notificacion, leido: true }
                    : notificacion
            )
        );
        await handleDeleteNotification(codNotificacion);
    };

    const handleDescargarPlanos = async () => {
        if (!categoriaPlano) {
            alert("Selecciona una categoría.");
            return;
        }

        if (!user || !user.codEmpresa) {
            alert("No se pudo obtener la información de la empresa. Intenta recargar la página.");
            return;
        }

        setDescargandoPlano(true);
        try {
            const api = getApiInstance();
            const response = await api.get(
                `/api/Mueble/DownloadPlanosYExcelPorCategoria?categoria=${encodeURIComponent(
                    categoriaPlano
                )}&codEmpresa=${user.codEmpresa}`,
                { responseType: "blob" }
            );
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `PlanosYExcel_${categoriaPlano}.zip`);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error(error);
            const errMsg =
                error?.response?.data ||
                "Error al descargar planos para la categoría.";
            alert(errMsg);
        } finally {
            setDescargandoPlano(false);
        }
    };

    return (
        <nav className="navbar">
            <div className="navbar__left">
                <div className="navbar__left__logo">
                    <Link to="/">
                        <img
                            src={Logo}
                            className="navbar__left__logo__img"
                            alt="Logo"
                        />
                    </Link>
                </div>
            </div>

            <div className="navbar__right">
                <div className="navbar__download-planos">
                    <select
                        value={categoriaPlano}
                        onChange={(e) => setCategoriaPlano(e.target.value)}
                        style={{ minWidth: "170px", height: "40px" }}
                    >
                        <option value="">Selecciona categoría</option>
                        <option value="Munich">BOOK MUNICH</option>
                        <option value="Copenhague">BOOK COPENHAGUE</option>
                        <option value="Miami">BOOK MIAMI</option>
                    </select>
                    <Button
                        onClick={handleDescargarPlanos}
                        disabled={!categoriaPlano || descargandoPlano}
                        icon={
                            <PiDownloadSimple
                                style={{ fontSize: "18px", marginRight: "6px" }}
                            />
                        }
                        label={
                            descargandoPlano ? "Descargando..." : "Descargar"
                        }
                        variant="filled"
                        style={{
                            minWidth: "110px",
                            height: "40px",
                            fontSize: "15px",
                            padding: "0 18px",
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                        }}
                    />
                </div>

                <Link to="/versions" className="navbar__versions">
                    <PiClockCounterClockwise />
                </Link>

                <div className="navbar__notification" ref={notificationRef}>
                    <div onClick={toggleNotificationMenu}>
                        {notificaciones.filter((x) => !x.leido).length > 0 ? (
                            <>
                                <span className="navbar__notification__badge">
                                    {
                                        notificaciones.filter((x) => !x.leido)
                                            .length
                                    }
                                </span>
                                <MdNotificationsActive />
                            </>
                        ) : (
                            <IoNotificationsOutline />
                        )}
                    </div>

                    {isNotificationMenuOpen &&
                        (notificaciones.filter((x) => !x.leido).length > 0 ? (
                            <div className="navbar__versions__menu">
                                <ul>
                                    {notificaciones
                                        .slice()
                                        .reverse()
                                        .map((notification) => (
                                            <li
                                                key={
                                                    notification.codNotificacion
                                                }
                                                className={`notification-item ${
                                                    notification.leido
                                                        ? "notification-read"
                                                        : ""
                                                }`}
                                            >
                                                <div
                                                    className="navbar__versions__notification__icon"
                                                    title={
                                                        notification.leido
                                                            ? "Leída"
                                                            : "Marcar como leída"
                                                    }
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        handleMarkAsRead(
                                                            notification.codNotificacion
                                                        );
                                                    }}
                                                >
                                                    {notification.leido ? (
                                                        <MdOutlineMarkEmailRead />
                                                    ) : (
                                                        <MdOutlineMarkEmailUnread />
                                                    )}
                                                </div>
                                                <div
                                                    className="notification-content"
                                                    onClick={(e) =>
                                                        handleNotificationClick(
                                                            e,
                                                            notification.enlace
                                                        )
                                                    }
                                                >
                                                    <h4>
                                                        {notification.titulo}
                                                    </h4>
                                                    <h5>
                                                        {formatDateComment(
                                                            notification.horaEnvio
                                                        )}
                                                    </h5>
                                                    <p>
                                                        {notification.mensaje}
                                                    </p>
                                                    <span>
                                                        -{" "}
                                                        {
                                                            notification.nombreUsuarioNotifica
                                                        }
                                                        {notification.apellidoUsuarioNotifica && 
                                                            ` ${notification.apellidoUsuarioNotifica}`
                                                        }{" "}
                                                        -
                                                    </span>
                                                </div>
                                            </li>
                                        ))}
                                </ul>
                                <div className="navbar__versions__footer">
                                    <Button
                                        onClick={handleDeleteAllNotifications}
                                        label="Marcar todas como leídas"
                                        variant="filled"
                                    />
                                </div>
                            </div>
                        ) : (
                            <div className="navbar__notification__menu_no_content">
                                No tienes notificaciones
                            </div>
                        ))}
                </div>

                <div className="navbar__avatar" ref={avatarRef}>
                    <div className="navbar__avatar__inner" onClick={toggleMenu}>
                        {user ? user.nombre.charAt(0).toUpperCase() : "?"}
                    </div>
                    {isMenuOpen && (
                        <div className="navbar__avatar__menu">
                            <div className="navbar__avatar__menu__header">
                                <div className="navbar__avatar__menu__header__name">
                                    {user
                                        ? `${user.nombre} ${user.apellidos}`
                                        : "Cargando..."}
                                </div>
                                <div className="navbar__avatar__menu__header__role">
                                    {user
                                        ? user.codPerfil === 1
                                            ? "Admin"
                                            : "Usuario"
                                        : "Cargando..."}
                                </div>
                            </div>
                            <ul>
                                <li>
                                    <NavLink to="/perfil">Mi Cuenta</NavLink>
                                </li>
                            </ul>
                            <Button
                                onClick={onLogout}
                                variant="filled"
                                icon={<MdLogout />}
                                label="Cerrar sesión"
                                fullWidth={true}
                            />
                        </div>
                    )}
                </div>
            </div>
        </nav>
    );
}
 